<template>
  <div class="header">
    <div class="header__logo">
      <img class="header__logo-img" :src="logo" />
    </div>
    <a :href="'tel:' + phone" class="header__contact-link">
      <img class="header__icon" src="@/assets/images/phone.png" />
      <span class="header__contact-link-text">{{ phone }}</span>
    </a>
    <a :href="website" class="header__contact-link">
      <img class="header__icon" src="@/assets/images/website.png" />
      <span class="header__contact-link-text">{{ $t('website') }}</span>
    </a>
    <div class="header__language-selector">
      <language-selector-component />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import LanguageSelectorComponent from './languageSelector.vue'
import { config } from '@/setup/config'
import defaultLogo from '@/assets/images/mainLogo.png'

@Component({
  components: {
    LanguageSelectorComponent
  },
  i18n: {
    messages: {
      en: {
        website: 'Website'
      },
      ru: {
        website: 'Веб-сайт'
      }
    }
  }
})
export default class HeaderComponent extends Vue {
  get phone () {
    return config.company.phone
  }

  get website () {
    return config.company.website
  }

  get logo () {
    const branding = config.company.customBranding
    if (branding.useCustomBranding) {
      return branding.customLogoPath ? branding.customLogoPath : ''
    } else {
      return defaultLogo
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  padding: $content-padding;
  &__logo {
    display: flex;
    align-items: center;
    flex: 1;
  }
  &__logo-img {
    height: 40px;
  }
  &__title {
    font-size: $font-size-large;
    font-family: $font-family-display;
    font-weight: $font-weight-semi-bold;
    text-transform: uppercase;
    color: $primary;
    margin: 0 0 0 10px;
  }
  &__contact-link {
    display: flex;
    align-items: center;
    margin-right: 30px;
    text-decoration: none;
    color: $text-primary;
  }
  &__contact-link-text {
    padding-bottom: 1px;
    border-bottom: 1px dotted $text-primary;
  }
  &__icon {
    height: 30px;
    margin-right: 8px;
  }
  &__language-selector {
    flex: 0 0 65px;
    margin-left: 10px;
  }
}
</style>